	<div
		class="flex justify-content-start align-items-end flex-wrap gap-2 w-full pt-3"
	>
		<mat-form-field>
			<mat-label>Start</mat-label>
			<input
				matInput
				[max]="today"
				[matDatepicker]="fromPicker"
				[(ngModel)]="fromDate"
				(ngModelChange)="handleFilterChange()"
			/>
			<mat-datepicker-toggle
				matIconSuffix
				[for]="fromPicker"
			></mat-datepicker-toggle>
			<mat-datepicker #fromPicker></mat-datepicker>
		</mat-form-field>

		<mat-form-field>
			<mat-label>End</mat-label>
			<input
				matInput
				[max]="today"
				[matDatepicker]="toPicker"
				[(ngModel)]="toDate"
				(ngModelChange)="handleFilterChange()"
			/>
			<mat-datepicker-toggle
				matIconSuffix
				[for]="toPicker"
			></mat-datepicker-toggle>
			<mat-datepicker #toPicker></mat-datepicker>
		</mat-form-field>

		<mat-form-field>
			<mat-label>Select Location</mat-label>
			<mat-select
				[(value)]="locationId"
				(selectionChange)="handleFilterChange($event)"
			>
				<mat-option *ngFor="let location of locations" [value]="location.Id">
					{{ location.Name }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<div class="pb-4">
			<button
				[matMenuTriggerFor]="exportFileType"
				mat-flat-button
				color="primary"
			>
				Export
				<mat-icon matSuffix>download</mat-icon>
			</button>
		</div>

		<mat-menu #exportFileType="matMenu">
			<button mat-menu-item (click)="exportReport(fileTypeOptions.Excel)">
				XLSX
			</button>
			<button mat-menu-item (click)="exportReport(fileTypeOptions.CSV)">
				CSV
			</button>
			<button mat-menu-item (click)="exportReport(fileTypeOptions.PDF)">
				PDF
			</button>
		</mat-menu>
	</div>

	<div class="grid">
		<!-- Most Popular Products -->
		<div class="col-12 md:col-6">
			<most-popular-products
				[locationId]="locationId"
				[fromDate]="fromDate"
				[toDate]="toDate"
			>
			</most-popular-products>
		</div>

		<!-- Slowest Moving Products -->
		<div class="col-12 md:col-6">
			<slowest-moving-products
				[locationId]="locationId"
				[fromDate]="fromDate"
				[toDate]="toDate"
			>
			</slowest-moving-products>
		</div>

		<!-- Most Popular Combinations -->
		<div class="col-12 md:col-6">
			<most-popular-combinations
				[locationId]="locationId"
				[fromDate]="fromDate"
				[toDate]="toDate"
			>
			</most-popular-combinations>
		</div>

		<!-- Most Searched Products -->
		<div class="col-12 md:col-6">
			<most-searched-products
				[locationId]="locationId"
				[fromDate]="fromDate"
				[toDate]="toDate"
			>
			</most-searched-products>
		</div>
	</div>
